// extracted by mini-css-extract-plugin
export var addOn = "add-on-block-module--addOn--76b57";
export var addOnRow = "add-on-block-module--addOnRow--6e325";
export var section = "add-on-block-module--section--10bf6";
export var sectionHeading = "add-on-block-module--sectionHeading--48889";
export var sectionSubheading = "add-on-block-module--sectionSubheading--373c0";
export var sectionTitle = "add-on-block-module--sectionTitle--00ac6";